import type { Mcc } from "./types";

// 12-month chargeback seasonality multipliers per MCC (May 2025 → Apr 2026).
export const MCC_CB_PROFILE: Record<Mcc, number[]> = {
  "5999": [0.55, 0.6, 0.9, 0.8, 0.6, 1.0, 0.85, 0.65, 0.55, 0.5, 0.52, 0.7],
  "5968": [0.8, 0.9, 0.7, 0.55, 0.75, 0.95, 0.8, 0.6, 0.5, 0.48, 0.5, 0.65],
  "7372": [0.5, 0.48, 0.85, 0.5, 0.52, 0.95, 0.7, 0.45, 0.4, 0.4, 0.42, 0.8],
  "5815": [0.75, 0.55, 0.5, 0.45, 0.55, 0.85, 0.65, 0.48, 0.45, 0.44, 0.48, 0.9],
  "5122": [0.55, 0.6, 0.9, 0.8, 0.6, 0.88, 0.78, 0.55, 0.48, 0.46, 0.5, 0.58],
  "7273": [1.4, 1.1, 0.85, 0.68, 0.75, 0.95, 0.7, 0.55, 0.48, 0.46, 0.5, 0.55],
  "5816": [1.0, 0.88, 0.6, 0.5, 0.85, 0.65, 0.48, 0.45, 0.45, 0.42, 0.44, 0.55],
  "4899": [0.5, 0.52, 0.58, 0.5, 0.52, 0.55, 0.48, 0.48, 0.48, 0.48, 0.52, 1.1],
};

// Per-merchant chargeback drift per active month (only applied when cbMult > 1).
export const MCC_DRIFT: Record<Mcc, number> = {
  "5999": 0.00004,
  "5968": 0.00005,
  "7372": 0.000018,
  "5815": 0.000016,
  "5122": 0.000038,
  "7273": 0.000062,
  "5816": 0.00003,
  "4899": 0.000012,
};

// Projected monthly ramp (bps/mo) — used in breach forecasts.
export const MCC_RAMP: Record<Mcc, number> = {
  "5999": 0.022,
  "5968": 0.028,
  "7372": 0.012,
  "5815": 0.01,
  "5122": 0.025,
  "7273": 0.04,
  "5816": 0.018,
  "4899": 0.008,
};

export const MCC_VISA: Record<Mcc, number> = {
  "5999": 0.62,
  "5968": 0.65,
  "7372": 0.58,
  "5815": 0.68,
  "5122": 0.6,
  "7273": 0.52,
  "5816": 0.63,
  "4899": 0.7,
};

export const MCC_ATV: Record<Mcc, string> = {
  "5999": "€38–55",
  "5968": "€28–40",
  "7372": "€160–380",
  "5815": "€10–18",
  "5122": "€47–58",
  "7273": "€26–30",
  "5816": "€13–15",
  "4899": "€20",
};

export const BASE = "2025-05-01";
export const PB = "2026-05-01";
export const NOW_YYYYMM = "2026-04";
